import { InstallationReportSectionConfig } from '../model/installation-reporting-mdu-section.types';
import {
  ItemAnswer,
  SectionState,
} from './installation-reporting-mdu-section-state.types';

export const isSelfInspectionAnswerComplete = (
  answer: ItemAnswer | undefined,
): boolean => !!(answer?.completed || answer?.isNotCompletable);

export const completedConfiguredItemCount = (
  items: InstallationReportSectionConfig['items'],
  itemAnswers: SectionState['itemAnswers'],
): number =>
  items.filter((item) => isSelfInspectionAnswerComplete(itemAnswers[item.id]))
    .length;
